import type { ReactNode } from "react"
import { CircleAlertIcon } from "lucide-react"
import { Alert, AlertDescription, AlertTitle } from "@f2e/ui/components/base"

export interface AuthRedirectAlertProps {
  title: string
  description: ReactNode
}

const AuthRedirectAlert = ({ title, description }: AuthRedirectAlertProps) => {
  return (
    <Alert
      variant="destructive"
      className="mx-auto mb-6 max-w-sm rounded-md border-destructive/30 bg-destructive/5 px-4 py-4 [&>svg]:size-5"
    >
      <CircleAlertIcon aria-hidden />
      <AlertTitle className="font-semibold">{title}</AlertTitle>
      <AlertDescription className="mt-2 leading-6">
        {description}
      </AlertDescription>
    </Alert>
  )
}

export default AuthRedirectAlert
